export class LoginModal {
    email: string = "";
    password: string = "";
    recaptcha: string = "";
    provider_id: string = ""
}

export interface LogoutModal {
    refresh_token: string;
    user_guid: string;
    access_token: string;
}

export class ForgetDoctorPasswordModal {
    e_email: string = "";
    recaptcha: string = "";
}

export class VerifyUserID_Body {
    e_email: string = "";
    recaptcha: string = "";
}
